import { render, staticRenderFns } from "./Pendientes.vue?vue&type=template&id=2cef26ec&scoped=true"
import script from "./Pendientes.vue?vue&type=script&lang=js"
export * from "./Pendientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cef26ec",
  null
  
)

export default component.exports